import React, { useEffect, useRef } from "react";
import { Helmet } from "react-helmet";
import Slider from 'react-slick';
import ContactBlock from "../components/ContactBlock";
import Portfolio from "../components/Portfolio";
import WOW from 'wowjs';
import 'animate.css';

import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { Link } from "react-router-dom";

gsap.registerPlugin(ScrollTrigger);

const Home = () => {
  const handleScrollNav = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };  
  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = "./zahid.pdf";
    link.download = "Zahid Hussain Frontend Dev";
    link.click();
  };
  const elementsRef = useRef([]); // Array of refs for multiple elements

  useEffect(() => {
    elementsRef.current.forEach((el) => {
      if (el) {
        gsap.fromTo(
          el,
          { opacity: 0, y: 50 }, // Start state
          {
            opacity: 1,
            y: 0, // End state
            duration: 1,
            ease: 'power2.out',
            scrollTrigger: {
              trigger: el,
              start: 'top 80%',
              toggleActions: 'play none none reverse',
            },
          }
        );
      }
    });
  }, []);

  useEffect(() => {
    new WOW.WOW({
      live: false,
    }).init();
  }, []);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: true,
    autoplay: true, // Enables auto-play
    autoplaySpeed: 3000, // Adjust the auto-play speed (3 seconds)
    centerMode: false, // Centers the active slide
    centerPadding: "50px", // Adds some padding for better centering effect
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false, // Keep center mode on smaller screens
          centerPadding: "30px",
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          centerMode: false,
          centerPadding: "40px",
        },
      },
    ],
  };
  
  return (
    <>
      <Helmet>
        <title>Zahid Hussain - Portfolio</title>
      </Helmet>
      <section id="home" className="main-hero-area">
        <div className="container">
          <div className="container-inner">
            <div className="row align-items-center">
              <div className="col-lg-12 col-sm-12">
                <div ref={(el) => elementsRef.current[0] = el} style={{ opacity: 0 }}>
                  <div className="hero-content rmb-25 text-center">
                    <h1>I'm <span>Zahid</span> Hussain</h1>
                    <div className="job"><span>Software Engineer</span><span>Frontend Developer</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* about section */}
      <section id="about" className="about-area">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-5">
              <div ref={(el) => elementsRef.current[1] = el} style={{ opacity: 0 }}>
                <div className="about-image-part">
                  <img src="https://ca.slack-edge.com/T02APBMCR32-U02URQM6524-eef054c78170-512" alt="About Me" />
                  <h2>Zahid Hussain</h2>
                  <div className="about-btn btn-one text-center">
                    <h6>Available for Work</h6>
                    <div className="circle pulse color-pulse">
                    </div>
                  </div>
                  <div className="about-social text-center">
                    <ul>
                      <li>
                        <a  href="https://api.whatsapp.com/send?phone=+923025788489&amp;text=Hi,%20I%20would%20like%20to%20get%20more%20information.." 
                          target="_blank" 
                          rel="noopener noreferrer" 
                          ><i className="ri-whatsapp-line"></i>
                        </a>
                        
                      </li>
                      <li><a href="https://www.fiverr.com/s/2KdeBQX" 
                          target="_blank" 
                          rel="noopener noreferrer" ><i className="ri-messenger-line"></i></a></li>
                      <li><a  href="https://www.linkedin.com/in/zahid-hussain-691611251" 
                          target="_blank" 
                          rel="noopener noreferrer" ><i className="ri-linkedin-fill"></i></a></li>
                      <li><a  href="https://www.instagram.com/rao_zahid_hussain/" 
                          target="_blank" 
                          rel="noopener noreferrer" ><i className="ri-instagram-line"></i></a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-7">
              <div className="about-content-part">
                <div ref={(el) => elementsRef.current[2] = el} style={{ opacity: 0 }}>
                  <h2>Hello, I’m Zahid Hussain, <br /> <span>Software Engineer</span> Based in Pakistan.</h2>
                  <div className="hero-btns">
                    <Link className="theme-btn" onClick={() => handleScrollNav('contact')}>Hire Me <i className="ri-mail-send-line"></i></Link>
                    <a href="/" className="theme-btn" onClick={(e) => { e.preventDefault(); handleDownload(); }}>Download CV <i className="ri-download-line"></i></a>
                  </div>
                </div>
                <div ref={(el) => elementsRef.current[3] = el} style={{ opacity: 0 }}>
                  <ul className="list-style-one two-column">
                    <li><i className="ri-arrow-right-up-line"></i> Web Development</li>
                    <li><i className="ri-arrow-right-up-line"></i> App Development</li>
                    <li><i className="ri-arrow-right-up-line"></i> Social Marketing</li>
                    <li><i className="ri-arrow-right-up-line"></i> Branding Identity</li>
                    <li><i className="ri-arrow-right-up-line"></i> Digital Marketing</li>
                    <li><i className="ri-arrow-right-up-line"></i> Website SEO</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* services */}
      <section id="services" className="services-area">
        <div className="container">
          <div className="row">
            <div className="col-xl-12 col-lg-12">
              <div >
                <div className="section-title text-center">
                  <p>Services</p>
                  <h2>Quality Services</h2>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4 col-md-6">
              <div ref={(el) => elementsRef.current[4] = el} style={{ opacity: 0 }}>
                <div className="service-item">
                  <i className="ri-global-fill"></i>
                  <h4>Brand Identity Design</h4>
                  <p>Crafting unique and memorable brand identities that capture the essence of your business. From logos to complete branding kits, I create designs that resonate with your audience.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div ref={(el) => elementsRef.current[5] = el} style={{ opacity: 0 }}>
                <div className="service-item">
                  <i className="ri-quill-pen-fill"></i>
                  <h4>Website Design &amp; Develop</h4>
                  <p>Building modern, responsive, and user-friendly websites tailored to your needs. Whether it's an e-commerce platform, portfolio, or corporate site, I ensure a seamless online presence.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div ref={(el) => elementsRef.current[6] = el} style={{ opacity: 0 }}>
                <div className="service-item">
                  <i className="ri-apps-fill"></i>
                  <h4>Application Design &amp; Develop</h4>
                  <p>Building robust and scalable applications designed to streamline operations and elevate user experiences. From concept to launch, I provide high-performance solutions tailored to your needs.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* experience */}
      <section id="resume" className="resume-area">
        <div className="container">
          <div className="row">
            <div className="col-xl-12 col-lg-12">
              <div ref={(el) => elementsRef.current[7] = el} style={{ opacity: 0 }}>
                <div className="section-title text-center wow fadeInUp delay-0-2s">
                  <p>Experience</p>
                  <h2> What Have I Achieved?</h2>
                </div>
              </div>
            </div>
          </div>
          <div className="resume-items">
            <div className="row">
              <div className="col-xl-6 col-md-6 mb-3 mb-md-0">
                <div className="experience-list">
                  <div ref={(el) => elementsRef.current[10] = el} style={{ opacity: 0 }}>
                    <div className="resume-item">
                      <div className="icon">
                      <i className="ri-user-2-line"></i>
                      </div>
                      <div className="content">
                        <span className="years">2025 - Present</span>
                        <h4>Frontend Developer</h4>
                        <span className="company">Highnoon Laboratories Limited </span>
                      </div>
                    </div>
                  </div>
                  <div ref={(el) => elementsRef.current[8] = el} style={{ opacity: 0 }}>
                    <div className="resume-item">
                      <div className="icon">
                     <i className="ri-user-line"></i>
                      </div>
                      <div className="content">
                        <span className="years">2022 - 2025</span>
                        <h4>Frontend Developer</h4>
                        <span className="company">Einnovention Software Solutions</span>
                      </div>
                    </div>
                  </div>
                  <div ref={(el) => elementsRef.current[22] = el} style={{ opacity: 0 }}>
                    <div className="resume-item border-b-0 pb-0">
                      <div className="icon">
                      <i className="ri-code-s-slash-line"></i>
                      </div>
                      <div className="content">
                        <span className="years">2021 - 2022</span>
                        <h4>Internship Web-development</h4>
                        <span className="company">Eziline pvt, ltd</span>
                      </div>
                    </div>
                  </div>
                  {/* <div ref={(el) => elementsRef.current[10] = el} style={{ opacity: 0 }}>
                    <div className="resume-item">
                      <div className="icon">
                      <i className="ri-command-line"></i>
                      </div>
                      <div className="content">
                        <span className="years">2020 - 2021</span>
                        <h4>Logo Designer</h4>
                        <span className="company">Freelancer, Fiverr</span>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
              <div className="col-xl-6 col-md-6">
                <div className="experience-list">
                  <div ref={(el) => elementsRef.current[11] = el} style={{ opacity: 0 }}>
                    <div className="resume-item">
                      <div className="icon">
                      <i className="ri-graduation-cap-line"></i>
                      </div>
                      <div className="content">
                        <span className="years">2017 - 2021</span>
                        <h4>Bachelor Degree of Computer Science</h4>
                        <span className="company">University Agriculture FSD</span>
                      </div>
                    </div>
                  </div>
                  <div ref={(el) => elementsRef.current[9] = el} style={{ opacity: 0 }}>
                    <div className="resume-item">
                      <div className="icon">
                      <i className="ri-shield-star-line"></i>
                      </div>
                      <div className="content"><span className="years">2015 - 2017</span><h4>Higher secoundery Education</h4><span className="company">Punjab Groups of Colleges</span>
                      </div>
                    </div>
                  </div>
                  <div ref={(el) => elementsRef.current[12] = el} style={{ opacity: 0 }}>
                    <div className="resume-item border-b-0 pb-0">
                      <div className="icon"><i className="ri-award-line"></i>
                      </div>
                      <div className="content">
                        <span className="years">2015</span>
                        <h4>Matric</h4>
                        <span className="company">Punjab School System</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* portfolio */}
      <Portfolio />
      {/* testimonials */}
      <section className="testimonials-area">
        <div className="container">
          <div className="row">
            <div className="col-xl-12 col-lg-12">
              <div  >
                <div className="section-title text-center wow fadeInUp delay-0-2s">
                  <p>Testimonials</p>
                  <h2>What clients say!</h2>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="testimonials-wrap">
                <Slider {...settings}>
                  <div className="testimonial-item">
                    <div className="author">
                      <img src="./images/author2.jpg" alt="Author" />
                    </div>
                    <div className="text">Working with Zahid was an absolute pleasure. They turned our vision into reality and created a website that not only looks stunning but also performs seamlessly. Their attention to detail and ability to deliver on time exceeded our expectations.
                    </div>
                    <div className="testi-des">
                      <h5>Sarah J.</h5>
                      <span> Marketing Manager — Techware.</span>
                    </div>
                  </div>
                  <div className="testimonial-item">
                    <div className="author">
                      <img src="./images/author1.jpg" alt="David" />
                    </div>
                    <div className="text">I was impressed by Zahid's technical expertise and creativity. They transformed our outdated website into a modern, responsive platform that has significantly boosted our online presence. Highly recommended!
                    </div>
                    <div className="testi-des">
                      <h5>David Doe</h5>
                      <span>CEO &amp; Founder TechWave Inc</span>
                    </div>
                  </div>
                  <div className="testimonial-item">
                    <div className="author">
                      <img src="./images/author2.jpg" alt="Author" />
                    </div>
                    <div className="text">We approached Zahid with a complex project and a tight deadline, and they delivered beyond our expectations. Their professionalism, clear communication, and dedication to quality make them a standout developer.
                    </div>
                    <div className="testi-des">
                      <h5>Emma P.</h5>
                      <span>CEO — GreenLeaf Designs</span>
                    </div>
                  </div>
                  <div className="testimonial-item">
                    <div className="author">
                      <img src="./images/author1.jpg" alt="David" />
                    </div>
                    <div className="text">Thanks to Zahid, our e-commerce site is now user-friendly and visually appealing. Sales have increased, and our customers love the new design. We couldn't be happier!
                    </div>
                    <div className="testi-des">
                      <h5>Michael R</h5>
                      <span>Owner TrendyMart Online</span>
                    </div>
                  </div>
                </Slider>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* pricing plan */}
      <section className="pricing-area">
        <div className="container">
          <div className="row">
            <div className="col-xl-12 col-lg-12">
              <div >
                <div className="section-title text-center wow fadeInUp delay-0-2s">
                  <p>Pricing</p>
                  <h2>Flexible Pricing Plan</h2>
                </div>
              </div>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-lg-4 col-md-6">
              <div>
                <div className="pricing-item ">
                  <div className="pricing-header">
                    <h4 className="title">Basic</h4>
                    <p className="save-percent">Have design ready to build? <br /> or small budget</p>
                    <span className="price">15</span>
                  </div>
                  <div className="pricing-details">
                    <ul><li className=""><i className="ri-arrow-right-line"></i>Need your wireframe</li><li className=""><i className="ri-arrow-right-line"></i>Design with Figma, Framer</li><li className=""><i className="ri-arrow-right-line"></i>Product Design</li><li className="unable"><i className="ri-arrow-right-line"></i>Digital Marketing</li><li className="unable"><i className="ri-arrow-right-line"></i>Custom Support</li></ul><a href="/" className="theme-btn">Order Now <i className="ri-shopping-cart-line"></i></a>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div>
                <div className="pricing-item ">
                  <div className="pricing-header"><h4 className="title">Standard</h4><p className="save-percent">Not have any design? <br /> Leave its for me</p><span className="price">59</span>
                  </div>
                  <div className="pricing-details"><ul><li className=""><i className="ri-arrow-right-line"></i>Website Design</li><li className=""><i className="ri-arrow-right-line"></i>Mobile Apps Design</li><li className=""><i className="ri-arrow-right-line"></i>Product Design</li><li className=""><i className="ri-arrow-right-line"></i>Digital Marketing</li><li className="unable"><i className="ri-arrow-right-line"></i>Custom Support</li></ul><a href="/" className="theme-btn">Order Now <i className="ri-shopping-cart-line"></i></a>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div>
                <div className="pricing-item ">
                  <div className="pricing-header"><h4 className="title">Standard</h4><p className="save-percent">Not have any design? <br /> Leave its for me</p><span className="price">59</span>
                  </div>
                  <div className="pricing-details"><ul><li className=""><i className="ri-arrow-right-line"></i>Website Design</li><li className=""><i className="ri-arrow-right-line"></i>Mobile Apps Design</li><li className=""><i className="ri-arrow-right-line"></i>Product Design</li><li className=""><i className="ri-arrow-right-line"></i>Digital Marketing</li><li className="unable"><i className="ri-arrow-right-line"></i>Custom Support</li></ul><a href="/" className="theme-btn">Order Now <i className="ri-shopping-cart-line"></i></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* blogs */}
      <section id="blog" className="blog-area">
        <div className="container">
          <div className="row">
            <div className="col-xl-12 col-lg-12">
              <div>
                <div className="section-title text-center wow fadeInUp delay-0-2s"><p>blog</p><h2>Latest Blog</h2>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4 col-md-6">
              <div >
                <div className="blog-item">
                  <div className="image"><img src="./images/blog1.jpg" alt="Blog" />
                  </div>
                  <div className="content">
                    <div className="blog-meta mt-15"><a className="date" href="/"><i className="ri-calendar-2-line"></i>January 15, 2024</a>
                    </div>
                    <h5>
                      <a href="/">Spotlight — Equinox Collection by Shane Griffin</a></h5><p>Looking for inspiration to kick it off, I stumbled across the work of Shane...</p><hr /><a href="/" className="theme-btn">Read More<i className="ri-more-line"></i></a>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div >
                <div className="blog-item">
                  <div className="image"><img src="./images/blog2.jpg" alt="Blog" />
                  </div>
                  <div className="content">
                    <div className="blog-meta mt-15"><a className="date" href="/"><i className="ri-calendar-2-line"></i>February 22, 2024</a>
                    </div>
                    <h5>
                      <a href="/">Random Explorations with Cinema 4D and Redshift</a></h5><p>Nidia Dias is a 3D designer based in the Portugal with an incredible portfolio...</p><hr /><a href="/" className="theme-btn">Read More<i className="ri-more-line"></i></a>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div >
                <div className="blog-item">
                  <div className="image"><img src="./images/blog3.jpg" alt="Blog" />
                  </div>
                  <div className="content">
                    <div className="blog-meta mt-15"><a className="date" href="/"><i className="ri-calendar-2-line"></i>February 25, 2024</a>
                    </div>
                    <h5>
                      <a href="/">Random Explorations with Cinema 4D and Redshift</a></h5><p>Nidia Dias is a 3D designer based in the Portugal with an incredible portfolio...</p><hr /><a href="/" className="theme-btn">Read More<i className="ri-more-line"></i></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* contact form section */}
      <ContactBlock />
    </>
  );
};

export default Home;
